import { Field } from 'formik'
import React from 'react'

import { Fieldset, Input } from '@fourthwall/components'

export const NumberForm = () => {
  return (
    <>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field name="label" component={Input} label="Label" placeholder="Setting label" />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            name="info"
            component={Input}
            label="Info (optional)"
            placeholder="Help text for this setting"
          />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            name="default"
            component={Input}
            label="Default Value (optional)"
            placeholder="Default value"
          />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            name="placeholder"
            component={Input}
            label="Placeholder (optional)"
            placeholder="Placeholder text"
          />
        </Fieldset.Item>
      </Fieldset.Row>
    </>
  )
}
